import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid w-full grid-cols-1 sm:grid-cols-2 justify-items-center" }

import LogOut from "@/components/LogOut.vue";
import HomeCard from "@/components/HomeCard.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LogOut),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HomeCard, {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'equipmentHome' })), ["prevent"])),
        title: "Dream Pick&Track",
        description: "Questa funzione permette di visualizzare, censire e modificare le attrezzature",
        image: "card_censimento.webp"
      }),
      _createVNode(HomeCard, {
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'odsHome' })), ["prevent"])),
        title: "Dream Way",
        description: "Questa funzione permette di visualizzare e gestire gli ordini di servizio",
        image: "card_ods.webp"
      })
    ])
  ], 64))
}
}

})